import { MenuDto } from 'src/graphql/generated-types';

const actionBaseName = '[Menu] ';

export class GetMenusListAction {
    static readonly type = actionBaseName + 'GetMenusList';
}

export class SelectMenuAction {
  static readonly type = actionBaseName + 'SelectMenu';

    constructor(public menu: MenuDto = null) {
    }
}

export class SetActivatedMenusListAction {
  static readonly type = actionBaseName + 'SetActivatedMenusList';

    constructor(public activatedMenusList: MenuDto[] = []) {
    }
}
